<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.referentActivity',1) }}
                    </h3>
                </div>
            </div>

            <div class=" " :class="[ mobileView ? 'pt-3': 'card-body']">
                <b-form>
                    <div class=" " :class="[ mobileView ? '' : 'container']">
                        <b-row>
                            <div class="form-group col-md-12">
                                <span class="obligatoire">*</span>
                                <label for="etablissement_id">{{ $t('message.nomEtablissement') }}</label>
                                <autocomplete
                                    :search="getEtablisssements"
                                    placeholder="Rechercher l'établissement"
                                    aria-label="Rechercher l'établissement"
                                    :get-result-value="getValueEtablissement"
                                    @submit="chooseEtablissement"
                                ></autocomplete>
                                <input type="hidden" name="etablissement_id" id="etablissement_id" v-model="$v.form.etablissement_id.$model" class="form-control" v-validate="'required'" :class="errors.has('etablissement_id') ? 'is-invalid' : ''"/>
                                <small id="emailHelp" class="form-text text-danger" v-if="$v.form.etablissement_id.$error">Rassurez-vous d'avoir sélectionné un établissement</small> 
                            </div>
                            
                            <div class="form-group col-md-9">
                                <span class="obligatoire">*</span>
                                <label for="exampleInputEmail1">Patient</label>
                                <autocomplete
                                    :search="getPatients"
                                    placeholder="Rechercher le patient"
                                    aria-label="Rechercher le patient"
                                    :get-result-value="getValueSouscripteur"
                                    @submit="choosePatient"
                                ></autocomplete>
                                <input type="hidden" name="patient_id" id="patient_id" v-model="$v.form.patient_id.$model" class="form-control" v-validate="'required'" :class="errors.has('patient_id') ? 'is-invalid' : ''"/>
                                <small id="emailHelp" class="form-text text-danger" v-if="$v.form.patient_id.$error">Rassurez-vous d'avoir sélectionné un patient</small> 
                            </div>
                            <div class="form-group col-md-3 mt-5">
                                <router-link :to="{ name: 'add-patient', params:{role: 'ama'}}">
                                <i class="fas fa-plus-circle edit-icon"></i>
                                <span class="nav-link-text"> {{$t("message.patient")}}</span>
                                </router-link>
                            </div>
                        

                            <b-col md="12" v-if="ligne_temps.length>0">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                id="ligne_temps_id-group"
                                :label="$t('message.Timeline')"
                                label-for="ligne_temps_id">
                                    <select id="ligne_temps_id" v-model="$v.form.ligne_temps_id.$model"
                                        @change="clearErrorField('ligne_temps_id')"
                                        class="custom-select"
                                        required>
                                        <option value="">Sélectionnez la ligne de temps</option>
                                        <option v-for="item in ligne_temps" :key="'ligne_temps'+item.id" :value="item.id">
                                            {{ item.motif.description }} ({{ item.date_consultation }}) {{ item.affiliation == null ? '' : ' | '+item.affiliation.package.description_fr }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.ligne_temps_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('ligne_temps_id')" style="color:red">
                                    {{getErrorsField('ligne_temps_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>     

                            <b-col sm="12">
                                <span class="obligatoire">*</span>
                                <b-form-group
                                        id="dateFacturation-group"
                                        :label="$t('message.dateactivity')"
                                        label-for="dateFacturation">
                                    <b-form-input
                                            id="dateFacturation"
                                            v-model="$v.form.date_cloture_activite.$model"
                                            :state="$v.form.date_cloture_activite.$dirty ? !(errorshasField('date_cloture_activite') || $v.form.date_cloture_activite.$error) : null"
                                            placeholder=""
                                            type="date"
                                            @focus="clearErrorField('date_cloture_activite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('date_cloture_activite')">
                                        {{ getErrorsField('date_cloture_activite') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.date_cloture_activite.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        <b-col sm="12">
                             <b-form-group
                                id="activity-group"
                                :label="$t('message.activity')"
                                label-for="activity">
                                <select id="activity" v-model="$v.form.selected.$model"
                                        @change="clearErrorField('selected')"
                                        class="form-control"
                                        required>
                                    <option value="">{{$t('message.sla')}}</option>
                                    <option v-for="item in missions" :key="item.id" :value="item.id" >
                                        {{ item.description_fr }}
                                    </option>
                                </select>
                                <b-form-invalid-feedback v-if="$v.form.selected.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <span v-if="errorshasField('selected')" style="color:red">
                                    {{ getErrorsField('selected') }}
                                </span>
                            </b-form-group>
                        </b-col>
                    </b-row>
                <b-form-group
                    id="commentaire-group"
                    :label="$tc('message.commentaires',1)"
                    label-for="commentaire">
                  <div v-if="$v.form.description.$model === '1'">
                    <!-- <slim-element return-value="text" selected-id="commentaire" :afficher="$v.form.description.$model === '1'" :element.sync="form.description" :data.sync="commentaireOptions"></slim-element> -->
                  </div>
                  <b-form-input v-if="$v.form.description.$model !== '1'"
                    id="dateCloture"
                    v-model="$v.form.description.$model"
                    :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                    required
                    @focus="clearErrorField('description')">
                    </b-form-input>
                  <b-form-invalid-feedback v-if="errorshasField('description')">
                    {{ getErrorsField('description') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <div>
                    <label class="form__label" for="hasDesc">{{ $t('message.missionCloture') }}</label>
                    <div class="toggle">
                        <input id="hasDesc" type="checkbox" v-model="$v.form.statut.$model"/>
                        <label for="hasDesc">
                        <div class="toggle__switch"></div>
                        </label>
                    </div>
                </div>
                <b-row class="justify-content-center">
                    <b-button @click="onSubmit" variant="primary">
                        {{ $t('message.enregistreractivity') }}
                    </b-button>
                </b-row>
                </div>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import router from '../../router/router';
    import _ from "lodash";
    import AppConfig from "../../constants/AppConfig";
    import {required} from "vuelidate/lib/validators";
    import SlimSelect from "slim-select";
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'
    import moment from "moment";
    import axios from "axios";

    export default {
        name: "Add",
        components: {
            Autocomplete,
        },
        computed: {
            ...mapGetters(['hasAdminRole', "errors",
                'hasGestionnaireRole', 'hasMedecinControleRole','isComptable','hasAssistante','amaActivites']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },
        },

        data(){
            return {
                 missions: [],
                 affiliations: [],
                 ligne_temps: [],
                 selected: null,
                 content: "",
                form : {
                    patient_id:null,
                    etablissement_id:null,
                    affiliation_id: '',
                    ligne_temps_id: '',
                    selected: "",
                    description: "",
                    statut: false,
                    date_cloture_activite: moment((new Date())).format('YYYY-MM-DD'),
                },
                mobileView: true,
            }
        },
        methods:{
            handleView() {
                this.mobileView = window.innerWidth <= 990;
            },
             getPatients(input) {
                return new Promise(resolve => {
                if (input.length < 3) {
                    return resolve([])
                }
                    fetch(AppConfig.apiUrl+'/search/patients/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.patients)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },

            getEtablisssements(input){
                return new Promise(resolve => {
                    if (input.length < 2) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/etablissements/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.etablissements)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getValueEtablissement(result) {
                return result.name
            },
            chooseEtablissement(result) {
                this.form.etablissement_id = result.id;
            },
            getValueSouscripteur(result) {
                return result.user.nom +' '+result.user.prenom +' ('+result.user.email+')'
            },
            choosePatient(result) {
                this.form.patient_id = result.user_id;
                if(this.form.patient_id != ""){
                    axios.get(`${AppConfig.apiUrl}/affiliations/${this.form.patient_id}`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
                    .then(res => {
                        this.ligne_temps = res.data.ligne_temps;
                        this.form.ligne_temps_id = "";
                        this.form.affiliation_id = "";
                    })
                    .catch((error) => {
                        console.log("error ", error)
                    });
                }
            },
            getGroupeActivites: function () {
                axios
                    .get(AppConfig.apiUrl + "/referent-activites/list")
                    .then((res) => (this.missions = res.data.activites))
                    .catch((error) => {window.console.log(error)});
            },
            getActivite() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };
                this.$store.dispatch("getReferentActivites", {args : args});
            },

            validerForm(evt){
                evt.preventDefault();

                this.$v.form.$touch();

                if(!this.$v.form.$invalid) {
                    this.continuer = true;
                }
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        etablissement_id: this.form.etablissement_id,
                        patient_id:this.form.patient_id,
                        date_cloture:this.form.date_cloture_activite,
                        activite_id:this.form.selected,
                        statut:this.form.statut,
                        commentaire:this.form.description
                    };

                    if(this.ligne_temps.length>0){
                        args = {...args, ligne_temps_id: this.form.ligne_temps_id, affiliation_id: this.form.affiliation_id};
                    };
                    // console.log("args ", args);

                    let successMessage = this.$i18n.t('message.ActivitesReferentCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                   this.$store.dispatch('createReferentActivite', { args, errorMessages, successMessage }).then(() => {
                      router.push({ name: 'medecin-referent' });
                    });
                }
            },


            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                if((field == "patient_id") && (this.form.patient_id != "")){
                    axios.get(`${AppConfig.apiUrl}/affiliations/${this.form.patient_id}`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
                    .then(res => {
                        this.affiliations = res.data.affiliations;
                        this.form.ligne_temps_id = "";
                        this.form.affiliation_id = "";
                        this.ligne_temps = [];
                        //console.log('res.data.affiliations ', res.data.affiliations)
                    })
                    .catch((error) => {
                         console.log("error ", error)
                    });
                }
                else if((field == "ligne_temps_id") && (this.form.ligne_temps_id != "")){ 
                    let ligne_temps = this.ligne_temps.find(item => item.id == this.form.ligne_temps_id);
                    this.form.affiliation_id = ligne_temps.affiliation_id == null ? "" : ligne_temps.affiliation_id;
                }
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },
        },

        validations() {
            return {

                form : {
                    patient_id: {required},
                    affiliation_id: {},
                    ligne_temps_id: {},
                    etablissement_id:{required},
                    date_cloture_activite:{required},
                    statut: {},
                    selected:{required},
                    description:{}
                },
            }
        },
        created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },
        mounted() {
            this.getActivite();
            this.getGroupeActivites();
            
        }
    }
</script>

<style scoped>
    @import "~slim-select/dist/slimselect.min.css";
</style>
